import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { InventoryLogStored } from '../models/Inventory';
import { toDate } from '../utils/timestamp';

type InventoryLogChartProps = {
  logs: InventoryLogStored[];
  unit: string;
};

const InventoryLogChart: React.FC<InventoryLogChartProps> = ({ logs, unit }) => {
  // Convert logs into chart-friendly data
  const data = logs
    .map((log) => ({
      date: toDate(log.timestamp),
      quantity: log.currentQuantity,
      action: log.action,
    }))
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tickFormatter={(d: Date) => new Date(d).toLocaleDateString('en-UK', { month: '2-digit', day: '2-digit' })}
        />
        <YAxis label={{ value: unit, angle: -90, position: 'insideLeft' }} />
        <Tooltip formatter={(value, _name, props) => [`${value} ${unit}`, `Quantity`]} />
        <Line type="monotone" dataKey="quantity" stroke="#8884d8" dot />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default InventoryLogChart;
